import { Component, OnInit } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { VolumeEstimatorGoalSetting } from '../../interfaces/volume-estimator-goal-setting';
import { VolumeEstimatorTarget } from '../../interfaces/volume-estimator-target';

import { VolumeEstimatorService } from '../../services/volume-estimator-service';
import { ToastService } from '../../../shared/services/toast.service';
import { ProjectionService } from '../../../performance/services/projection.service';
import { BranchProjectionOpenCloseDates } from '../../../performance/components/performance-projections-config/performance-projection.data';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';

@Component({
    selector: 'volume-estimator',
    templateUrl: './volume-estimator.component.html',
    styleUrls: ['./volume-estimator.component.scss'],
})
export class VolumeEstimatorComponent implements OnInit {
    pageTitle = 'Annual Commission Calculator';
    goalSetting: VolumeEstimatorGoalSetting = {
        annualCompensationTarget: null,
        averageLoanAmount: null,
        averageCommissionBps: null,
        leadToFundPullThru: null,
    };
    goalTarget: VolumeEstimatorTarget = {
        averageCompensationPerLoan: 0,
        fundedUnitsPerYear: 0,
        fundedUnitsPerMonth: 0,
        totalLeadsPerMonth: 0,
        totalLeadsPerYear: 0,
        totalLeadsPerWeek: 0,
    };
    result: Observable<VolumeEstimatorTarget> = null;
    branchProjOpenCloseDates: BranchProjectionOpenCloseDates[];
    displayYear: number;

    constructor(
        private volumeEstimatorService: VolumeEstimatorService,
        private toast: ToastService,
        private projectionService: ProjectionService,
        private reusableFunctions: ReusableFunctions
    ) {}

    ngOnInit() {
        this.projectionService.getBranchProjectionOpenCloseDates().subscribe((dates) => {
            this.branchProjOpenCloseDates = dates;
            this.displayYear = this.getDisplayYear();
        });
    }

    getDisplayYear() {
        if (!this.branchProjOpenCloseDates) {
            return new Date().getFullYear();
        } else {
            if (this.areThisYearsBranchProjections()) {
                return new Date().getFullYear();
            } else {
                return new Date().getFullYear() + 1;
            }
        }
    }

    areThisYearsBranchProjections() {
        let today = new Date();
        let closingDateThisYear = this.branchProjOpenCloseDates.find(
            (date) => date.projectionYear === today.getFullYear()
        ).closingDate;
        closingDateThisYear = new Date(
            this.reusableFunctions
                .getDateFromDateTimeOffset(closingDateThisYear)
                .setUTCHours(23, 59, 59)
        );
        return today <= closingDateThisYear;
    }

    calculateBtnDisabled() {
        if (
            this.goalSetting.averageCommissionBps == 0 ||
            this.goalSetting.leadToFundPullThru == 0
        ) {
            return true;
        }

        return !(
            this.goalSetting.annualCompensationTarget &&
            this.goalSetting.averageLoanAmount &&
            this.goalSetting.averageCommissionBps &&
            this.goalSetting.leadToFundPullThru
        );
    }

    calculateGoalTarget() {
        this.volumeEstimatorService.calculateGoalTarget(this.goalSetting).subscribe(
            (res) => {
                this.goalTarget = res;
            },
            (error) => {
                this.toast.error('Something went wrong.');
            }
        );
    }

    resetInputs() {
        this.resetObject(this.goalSetting, null);
        this.resetObject(this.goalTarget, null);
    }

    resetObject(object, value) {
        for (let property in object) {
            if (object.hasOwnProperty(property)) {
                object[property] = value;
            }
        }
    }
}
